
{
  "labels": {
    "image": "Photo"
  }
}
